import { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/AuthProvider';
import styles from './AppChrome.module.css';

const NAV_ITEMS = [
  { href: '/operate', label: 'Operar', id: 'operate', spa: true },
  { href: '/today', label: 'Hoy', id: 'today', spa: true },
  { href: '/pipeline', label: 'Pipeline', id: 'pipeline', spa: true },
  { href: '/library', label: 'Biblioteca', id: 'library', spa: true },
  { href: '/chat', label: 'Asistente', id: 'chat', spa: true },
  { href: '/templates', label: 'Plantillas', id: 'templates', spa: true },
  { href: '/import', label: 'Importar', id: 'import', spa: true },
  { href: '/datados', label: 'Datos', id: 'datados', spa: true },
];

export default function AppChrome({ children }: { children: React.ReactNode }) {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const activeId =
    NAV_ITEMS.find((item) => location.pathname.startsWith(item.href))?.id ?? '';

  useEffect(() => {
    function onClick(e: MouseEvent) {
      if (!menuRef.current?.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    }
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  return (
    <div className={styles.chrome}>
      <header className={styles.appHeader}>
        <Link to="/operate" className={styles.headerLogo}>
          <img
            src="https://logos.grandeandgordo.com/logoggblanco.png"
            alt="Grande&Gordo"
            className={styles.headerLogoImg}
          />
          <span className={styles.headerLogoTag}>CRM</span>
        </Link>
        <nav className={styles.headerNav} aria-label="Main navigation">
          {NAV_ITEMS.map((item) => {
            const isActive = activeId === item.id;
            const className = isActive ? styles.headerNavLinkActive : styles.headerNavLink;
            return item.spa ? (
              <Link
                key={item.id}
                to={item.href}
                className={className}
                data-nav={item.id}
              >
                <span>{item.label}</span>
              </Link>
            ) : (
              <a
                key={item.id}
                href={item.href}
                className={className}
                data-nav={item.id}
              >
                <span>{item.label}</span>
              </a>
            );
          })}
        </nav>
        <div className={styles.headerControls}>
          <div className={styles.headerUser} ref={menuRef}>
            <button
              className={styles.headerUserBtn}
              aria-label="Usuario"
              onClick={() => setMenuOpen((s) => !s)}
            >
              <span>{user?.name?.charAt(0).toUpperCase() ?? 'A'}</span>
            </button>
            <div
              className={`${styles.headerUserMenu} ${
                menuOpen ? styles.headerUserMenuOpen : ''
              }`}
            >
              <div className={styles.headerUserInfo}>
                <span className={styles.headerUserName}>
                  {user?.name ?? 'Admin'}
                </span>
                <span className={styles.headerUserEmail}>
                  {user?.email ?? 'admin@grandeandgordo.com'}
                </span>
              </div>
              <hr className={styles.headerUserDivider} />
              <button
                type="button"
                className={styles.headerUserLinkDanger}
                onClick={() => {
                  setMenuOpen(false);
                  logout();
                }}
              >
                Cerrar sesión
              </button>
            </div>
          </div>
        </div>
      </header>
      <main className={styles.mainContent}>
        <div className={styles.pageBody}>{children}</div>
      </main>
    </div>
  );
}
